export function normalizeSortValue(value, type = 'string') {
  if (value == null || value === '') {
    if (type === 'number' || type === 'date') {
      return null;
    }
    return '';
  }

  if (type === 'number') {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  if (type === 'date') {
    const t = new Date(value).getTime();
    return Number.isNaN(t) ? null : t;
  }

  return String(value).toLocaleLowerCase('fr');
}

export function compareSortValues(a, b, type = 'string') {
  const normA = normalizeSortValue(a, type);
  const normB = normalizeSortValue(b, type);

  if (normA === null && normB === null) return 0;
  if (normA === null) return 1;
  if (normB === null) return -1;

  if (type === 'number' || type === 'date') {
    return normA - normB;
  }

  return String(normA).localeCompare(String(normB), 'fr', { sensitivity: 'base' });
}

export function sortRows(rows, sortKey, direction, columnDefs = {}) {
  if (!sortKey || !Array.isArray(rows)) {
    return rows ?? [];
  }

  const def = columnDefs[sortKey];
  if (!def) {
    return rows;
  }

  const getValue = def.getValue ?? ((row) => row[sortKey]);
  const type = def.type ?? 'string';

  const sorted = [...rows].sort((a, b) => compareSortValues(getValue(a), getValue(b), type));
  return direction === 'desc' ? sorted.reverse() : sorted;
}

export function getNextSortState(current, nextKey) {
  if (current?.key === nextKey) {
    return {
      key: nextKey,
      direction: current.direction === 'asc' ? 'desc' : 'asc',
    };
  }
  return { key: nextKey, direction: 'asc' };
}
